import React from "react";
import { useSelector } from "react-redux";

import styles from "./phoneme.module.css";
import { srcPath } from "../../util/Path";
import PhonicsCard from "./PhonicsCard";
import { State } from "../../redux/store";

const getPhonicsCardPosition = (index: number): any => {
  const elm = document.querySelector(`#phonics_${index}`) as HTMLDivElement;
  if (!elm) return null;

  const center = 295;
  const { offsetLeft, offsetWidth } = elm;
  const diffCenter = offsetLeft + offsetWidth / 2 - center;
  let bottom = Math.abs(diffCenter) * 0.065;
  if (bottom > 25) bottom = bottom * 1.4;
  const rotate = diffCenter * -0.025;
  return { bottom, transform: `rotate(${rotate}deg)` };
};

interface Props {
  style?: any;
}

const Ribbon = (props: Props) => {
  const { style } = props;
  const { grade } = useSelector((state: State) => state.shared);
  const { phonics } = useSelector((state: State) => state.phoneme);

  return (
    <div className={styles.ribbonContainer} style={style}>
      <img
        className={styles.ribbon}
        src={srcPath(`phoneme/intro_icons/p${grade}_ribbon.png`)}
        alt=""
      />
      <div className={styles.ribbonPhonicsContainer}>
        {phonics.map((p, i) => (
          <PhonicsCard
            key={i}
            phonics={p}
            id={`phonics_${i}`}
            style={{ ...getPhonicsCardPosition(i) }}
          />
        ))}
      </div>
    </div>
  );
};

export default Ribbon;
